import ky from 'ky';
import { DEFAULT_API_OPTIONS } from '../config/ky';

export async function getProfile() {
  const res = await ky.get('profile?limit=100', DEFAULT_API_OPTIONS);
  const profile = await res.json();
  if (!profile) throw Error('API error');
  return profile;
}
